import { Otovo$Config } from '../../types/otovoweb';

function resolveTagManagerID(config: Otovo$Config) {
  if (!config?.BU_CONFIG) {
    // Issue with dynamic statically generated pages causes config to be
    // undefined for some reason. Adding a defensive check until we figure out
    // why this is.
    return null;
  }

  const { BU_CONFIG } = config;

  switch (BU_CONFIG.type) {
    case 'OWN_AND_OPERATE':
    case 'PLATFORM_PARTNER':
      // BU_CONFIG currently doesn't have env support (same config in
      // staging/prod), so GTM for partners can only be used in production.
      return process.env.NEXT_PUBLIC_VERCEL_ENV === 'production'
        ? BU_CONFIG.gtm_id
        : null;
    case 'WHITE_LABEL':
      return process.env.NEXT_PUBLIC_VERCEL_ENV === 'preview'
        ? 'GTM-59VJQGD' // Staging ID is hard coded for Holu for the same reasons as above.
        : BU_CONFIG.gtm_id;
    case 'RESELLER_PARTNER':
    default:
      return null;
  }
}

export default resolveTagManagerID;
